import { UserRoleCodes } from '@/types'

import { checkRights } from '@/helpers'

export default [
  {
    path: 'blog/posts/:id?/general',
    name: 'manager-posts-item-general',
    component: () =>
      import('../../../views/Manager/Blog/ManagerPostItemGeneral.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
  {
    path: 'blog/posts/:id?/seo',
    name: 'manager-posts-item-seo',
    component: () =>
      import('../../../views/Manager/Blog/ManagerPostItemSeo.vue'),
    beforeEnter: [checkRights],
    meta: {
      layout: 'TheManagerLayout',
      roles: [UserRoleCodes.Administrator, UserRoleCodes.Manager],
    },
  },
]
